import auth from "@/middleware/auth";
import hasRoles from "@/middleware/hasRoles";
import isActivatedUser from "@/middleware/isActivatedUser";
import checkIsVideoInWindow from "@/middleware/checkIsVideoInWindow";
import checkIsVideoMounted from "@/middleware/checkIsVideoMounted";
import checkAccountCompletion from "@/middleware/checkAccountCompletion";

export default {
  path: "",
  name: "ClinicDashboard",
  meta: {
    middlewares: [
      auth,
      hasRoles,
      isActivatedUser,
      checkIsVideoInWindow,
      checkIsVideoMounted,
      checkAccountCompletion,
    ],
    roles: ["clinic_owner"],
  },
  children: [
    {
      path: "clinic-account",
      name: "ClinicSettingsAccount",
      component: () =>
        import(
          /* webpackChunkName: "doctor-account" */ "@/components/Layouts/Doctor/ClinicAccount.ts.vue"
        ),
      children: [
        {
          path: "profile",
          name: "SettingsClinicProfile",
          component: () =>
            import(
              /* webpackChunkName: "account-profile" */ "@/views/Clinic/settings/Profile.vue"
            ),
        },
        {
          path: "services",
          name: "SettingsClinicServices",
          component: () =>
            import(
              /* webpackChunkName: "account-settings" */ "@/views/Clinic/settings/Services.ts.vue"
            ),
        },
        {
          path: "employees",
          name: "SettingsClinicEmployees",
          component: () =>
            import(
              /* webpackChunkName: "account-settings" */ "@/views/Clinic/settings/Employees.ts.vue"
            ),
        },
        {
          path: "invoice-data",
          name: "SettingsClinicInvoiceData",
          component: () =>
            import(
              /* webpackChunkName: "account-settings" */ "@/views/Clinic/settings/InvoiceData.vue"
            ),
        },
        {
          path: "patient_sms_notifications",
          name: "SettingsClinicSmsNotifications",
          component: () =>
            import(
              /* webpackChunkName: "account-settings" */ "@/views/Clinic/settings/SmsNotifications.ts.vue"
            ),
        },
      ],
    },
    {
      path: "statistics",
      name: "Statistics",
      component: () =>
        import(
          /* webpackChunkName: "statistics" */ "@/views/Statistics.ts.vue"
        ),
    },
    {
      path: "visits",
      name: "ClinicVisitsList",
      component: () =>
        import(
          /* webpackChunkName: "doctor-patient-list" */ "@/views/Clinic/VisitsList.ts.vue"
        ),
    },
    {
      path: "clinic-calendar",
      name: "ClinicCalendar",
      component: () =>
        import(
          /* webpackChunkName: "clinic-calendar" */ "@/views/Clinic/ClinicCalendar.ts.vue"
        ),
    },
    {
      path: "clinic-schedule",
      name: "ClinicSchedule",
      component: () =>
        import(/* webpackChunkName: "schedule" */ "@/views/Schedule.ts.vue"),
    },
  ],
};
